import { Component, Inject, OnInit } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { InfoService } from '../../common/info.service';
import { LanguageService } from '../../common/language.service';
import { AppConfig } from '../../models/config/app-config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  umgebung: string;
  version: string;
  currentLang: string;

  constructor(
    private languageService: LanguageService,
    private infoService: InfoService,
    @Inject(APP_CONFIG) appConfig: AppConfig
  ) {
    this.umgebung = appConfig.umgebung;
    this.currentLang = this.languageService.getLanguage();
  }

  ngOnInit() {
    this.infoService.getInfo().subscribe(
      (info) => this.version = info.app.version
    );
  }

  public getLanguagePathForFederalForeignOffice(): string {
    if (this.isGermanLanguage()) {
      return '';
    } else if (this.isFrenchLanguage()) {
      return 'fr';
    } else {
      return 'en';
    }
  }

  private isGermanLanguage(): boolean {
    return this.currentLang === 'de';
  }

  private isFrenchLanguage(): boolean {
    return this.currentLang === 'fr';
  }

}
